import axios from 'axios';

import Helpers from '../common/helpers';
import apiConstants from './constants/api-constants';

class RegisterApi {
  static register(data) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.register_routes.register, data);

    return axios(request);
  }

  static checkUserExist(user_name, email) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.register_routes.check_user_exist, {
      user_name,
      email,
    });

    return axios(request);
  }
}

export default RegisterApi;



// WEBPACK FOOTER //
// ./src/api/register-api.js